import { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';

/**
 * Botón de exportar de las solapas del tablero. El armado del .xlsx corre en
 * el browser y con doce meses de matriz tarda lo suyo, así que muestra el
 * spinner y se bloquea mientras tanto — si no, el segundo clic genera un
 * archivo duplicado.
 */
export function ExportarXlsxButton({
  onExport,
  label = 'Exportar a Excel',
  className,
}: {
  onExport: () => Promise<void>;
  label?: string;
  className?: string;
}) {
  const [exportando, setExportando] = useState(false);
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className={className}
      disabled={exportando}
      onClick={async () => {
        setExportando(true);
        try {
          await onExport();
        } finally {
          setExportando(false);
        }
      }}
    >
      {exportando ? (
        <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
      ) : (
        <Download className="h-4 w-4" aria-hidden />
      )}
      {label}
    </Button>
  );
}
